import * as React from 'react';
import Loadable from 'react-loadable';
const TermsAndConditionsContainer = Loadable({
    loader: () => import('./containers/TermsAndConditionsContainer'),
    loading: () => null
});

export default function (store: any, props: any) {
    return (
        <TermsAndConditionsContainer {...props} />
    );
}